import React from 'react'
import strings from '../../lang/strings'
import { formatNumber, string, customDateFormat } from '../../helper/common'
import ConfirmButton from '../../components/control/button/confirm_button'
import Styles from './item.module.css'
export default function ItemProduct(props) {
    const { list, selected } = props
    const getCategoryToKo = (category) => {
        switch (category) {
            case "period": return strings.product_period
        }
    }

    const displayEventLimit = (close) => {
        if (close) {
            return string.Format(strings.product_event_limit, customDateFormat(close))
        }
        return ''
    };

    return (
        <div className={`${Styles.productItemContainer} ${props.className}`}>
            {
                list.map((it, idx) => {
                    return (
                        <div key={idx} onClick={() => { props.onClick(it) }} className={`${Styles.itemContainer}`}>
                            <div className={`${Styles.itemHeaders} fs-12 sm-fs-10 f-b  mb-4`}>
                                <div className={`${Styles.itemHeadersEvent}`}>
                                    {
                                        it.close && (displayEventLimit(it.close))
                                        
                                    }
                                </div>
                                <div className='fs-12 sm-fs-10 f-b color-878c91'>{getCategoryToKo(it.category)}</div>
                            </div>

                            <div className={`fs-16 sm-fs-14 f-b color-3a3335 ${Styles.truncate2lines} ${Styles.itemName}`}>{it.name}</div>
                            <div className='fs-16 sm-fs-14  mt-4 f-b color-3a3335'>{string.Format(strings.item_package_period_for_user, it.period)}</div>
                            <div className={`fs-14 sm-fs-12 mt-4 color-3a3335 ${Styles.itemFullArea} ${Styles.truncate4lines}`}>{it.description}</div>
                            <div className='item-price-box mt-8 fs-16 sm-fs-14 f-sb color-3a3335' style={{textAlign : "right"}}>{string.Format(strings.price_format, formatNumber(it.price))}</div>
                            <ConfirmButton enabled={true} className={'btn-bottom fs-15 f-m d-center mt-16'} text={strings.buying} />
                        </div>
                    )
                })
            }
        </div>
    )
}